export default __webpack_public_path__ + "static/media/05AW1APR66.5653d96f.jpg";